import Pager from '@/components/PagerComponent'

import Multiselect from 'vue-multiselect'

import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import { PermissionEnum } from '@/enums/permissions.enum'
import { Modal } from 'bootstrap';

export default {

  components: {
    Multiselect,
    Pager
  },

  setup () {
    return { v$: useVuelidate() }
  },

  data () {
    return {
      profile: null,
      criterias: {
        selectedRoleName: '',
        selectedRoleDescription: '',
        selectedRolePermissions: [],
        selectedRoleInternal: false,
        selectedRoleLot: ''
      },
      responseErr: '',
      error: false,
      validationError: false,
      isProcessing: false,
      permissions: PermissionEnum
    }
  },

  created () {
    this.profile = this.$store.state.profiles.profile
    if(!this.profile) {
      this.$router.replace({ path: '/vue/profiles' })
    }
    else {
      this.criterias.selectedRoleName = this.profile.id
      this.criterias.selectedRoleDescription = this.profile.description
      this.criterias.selectedRolePermissions = this.profile.permissionsList
      this.criterias.selectedRoleInternal = this.profile.internal
      this.criterias.selectedRoleLot = this.profile.lot
    }
  },

  methods: {
    editProfile () {
      this.validationError = this.v$.$invalid

      if (!this.validationError) {
        this.edit()
      }
    },

    async edit () {
      this.isProcessing = true
      this.responseErr = null
      let successMsg = null

      this.$store.dispatch('profiles/edit', {
        roleName: this.criterias.selectedRoleName,
        roleDescription: this.criterias.selectedRoleDescription,
        rolePermissions: this.criterias.selectedRolePermissions,
        roleInternal: this.criterias.selectedRoleInternal,
        roleLot: this.criterias.selectedRoleLot
      }).then(
        () => {
          successMsg = this.$i18n.t('label.profile.profileUpdatedSuccess', [this.criterias.selectedRoleName] )
          this.showSuccess(successMsg)
          this.isProcessing = true
        },
        error => {
          this.error = true
          this.isProcessing = false
          this.responseErr = error || 'BAD_REQUEST'
        }
      )
    },

    status (validation) {
      return {
        'validation-error': validation.$invalid && this.validationError
      }
    },

    showError (msg) {
      let errorModal = new Modal(document.getElementById('errorModal'))
      errorModal.show()
      document.getElementById('errorModalMsg').innerHTML = this.$i18n.t('error.' + msg)
    },

    showSuccess (msg) {
      let successModal = new Modal(document.getElementById('successModal'))
      successModal.show()
      document.getElementById('successModalMsg').innerHTML = msg
    },

    leavePage () {
      this.$router.push({ name: 'profile-list' })
    },

    reset () {
      this.criterias.selectedRoleName = ''
      this.criterias.selectedRoleDescription = ''
      this.criterias.selectedRolePermissions = []
      this.criterias.selectedRoleInternal = false
      this.criterias.selectedRoleLot = ''
      this.validationError = false
      this.error = false
    }
  },

  validations() {
    return {
      criterias: {
        selectedRoleName: { required },
        selectedRoleDescription: {},
        selectedRolePermissions: { required },
        selectedRoleInternal: {},
        selectedRoleLot: { required }
      }
    }
  }
}
